import Button from '@/components/Button';
import { FiPlay } from '@/components/react-icons/main/index.esm';
import setQuery from '@/lib/setQuery';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import { query } from '@/redux/selectors/querySelectors';
import selectors from '@/redux/selectors/selectors';
import getReplayAvailability from './lib/getReplayAvailability';

export const ReplayButton = () => {
  const workflowLogId = useArgSelector(query, 'logId');
  const activeLog = useArgSelector(selectors.workflowLogsById, workflowLogId);
  const replayMode = useArgSelector(query, 'replayMode');

  if (replayMode === 'true' || !activeLog) {
    return null;
  }

  const availability = getReplayAvailability(activeLog);

  return (
    <span data-title={availability.title}>
      <Button size="sm" className="outline replay-button" icon={FiPlay} disabled={availability.disabled} onClick={() => setQuery({ replayMode: 'true' })}>
        Replay
      </Button>
    </span>
  );
};
